module.exports = __webpack_public_path__ + "img/img_recruit_top_tablet@3x.8cf5b75b.png";